module.exports = __webpack_public_path__ + "img/que.9d091300.png";